import { SVGIconType } from '../svgIcon';

export enum WordSelectionMode {
  SelectAllWords = 'SelectAllWords',
  HandpickKeywordsSuggestions = 'HandpickKeywordsSuggestions',
  HandpickKeywords = 'HandpickKeywords',
}

type WordSelectionModeDetailsType = {
  icon: SVGIconType;
  displayName: string;
};

export const WordSelectionModeDetails: Record<
  WordSelectionMode,
  WordSelectionModeDetailsType
> = {
  [WordSelectionMode.SelectAllWords]: {
    icon: SVGIconType.SelectAll,
    displayName: 'Select all words',
  },
  [WordSelectionMode.HandpickKeywordsSuggestions]: {
    icon: SVGIconType.SelectSuggest,
    displayName: 'Handpick keywords + suggestions',
  },
  [WordSelectionMode.HandpickKeywords]: {
    icon: SVGIconType.Click,
    displayName: 'Handpick keywords',
  },
};
